import { render, staticRenderFns } from "./EndWizard.vue?vue&type=template&id=0a47a987&scoped=true&"
import script from "./EndWizard.vue?vue&type=script&lang=js&"
export * from "./EndWizard.vue?vue&type=script&lang=js&"
import style0 from "./EndWizard.vue?vue&type=style&index=0&id=0a47a987&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a47a987",
  null
  
)

export default component.exports